const Index = () => import(`@/views/candidate/testing/Index.vue`);

import candidateTest from "@/middlewares/candidateTest";

const testRoutes = [
    {
        path: '',
        name: 'candidate.test',
        component: Index,
        meta: {
            middleware: candidateTest
        }
    },
];

export default testRoutes;
